/* Auth-transition loading moment: a calm, wordless full-height beat while the
   app resolves the user's session — the OAuth code→token exchange on
   /auth/callback, or RequireAuth's `state === 'checking'`. One quiet brand
   element (a breathing cyan accent ring, the HUD "acquiring your session"
   pulse) — no card, no border, no visible text.
   See docs/ux/2026-07-02-auth-transition-microstates.md §3.1 + §7. */
.screen {
  /* Fill the viewport below the ~64px header so the ring sits at the OPTICAL
     middle of the screen — at 70dvh it floated in the top third of the page. */
  min-height: calc(100vh - 160px);
  min-height: calc(100dvh - 160px);
  display: grid;
  place-items: center;
  padding: var(--space-6);
}

.mark {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 1.5px solid color-mix(in srgb, var(--accent) 48%, transparent);
  background: radial-gradient(
    circle at center,
    color-mix(in srgb, var(--accent) 14%, transparent),
    transparent 68%
  );
  box-shadow: var(--glow-med);
  animation: signInBreathe 2.6s ease-in-out infinite;
}

@keyframes signInBreathe {
  0%,
  100% {
    transform: scale(0.92);
    opacity: 0.6;
    box-shadow: var(--glow-low);
  }
  50% {
    transform: scale(1.04);
    opacity: 1;
    box-shadow: var(--glow-strong);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mark {
    animation: none;
    opacity: 0.9;
    transform: none;
  }
}
